const TagMap = {
    b: 'font-weight-bold',
    bb: 'font-weight-bold',
    c1: 'font-color-c1',
    c2: 'font-underline',
    c3: 'font-underline',
    c4: 'font-color-c4',
    f1: 'font-size-f1',
    f2: 'font-size-f2'
};
const TagMapOld = {
    b: 'font-weight-bold',
    c1: 'font-underline',
    c2: 'font-underline',
    c3: 'font-underline',
    c4: 'font-underline',
    nc1: 'font-underline'
};
export function formatTag(originContent, config) {
    if (!originContent) {
        return originContent;
    }
    const { type } = config || {};
    let _content = originContent.replace(/<(\w+)>(.*?)<\/\1>/g, function (match, tag, content) {
        if (type === 'title') {
            return content;
        }
        let classNames = '';
        if (tag === 'nc1') {
            classNames = TagMapOld[tag];
        }
        else {
            const regex = /[b]{1,2}|c[1-4]|f[1-3]/g;
            const tagNames = tag.match(regex) || [];
            const isOldStyleRule = tagNames[0] === 'b';
            classNames = tagNames
                .map((name) => isOldStyleRule ? TagMapOld[name] : TagMap[name] || '')
                .join(' ');
        }
        return `<span class='${classNames}'>${content}</span>`;
    });
    const regexSymbols = /\s*(▷|▶|◁|◀|★|☆|●|○|◆|◇|▽|▼|☞|☛|※)?\s*(\r+?\n+)\s*(▷|▶|◁|◀|★|☆|●|○|◆|◇|▽|▼|☞|☛|※)?\s*/g;
    _content =
        type === 'title'
            ? _content.replace(regexSymbols, '')
            : type === 'reminder'
                ? _content.replace(regexSymbols, '<br/>')
                : _content.replace(regexSymbols, function () {
                    return '<div class="content-delimiter-block"></div>';
                });
    const regexSymbols2 = /^\s*(▷|▶|◁|◀|★|☆|●|○|◆|◇|▽|▼|☞|☛|※)\s*|\s*(▷|▶|◁|◀|★|☆|●|○|◆|◇|▽|▼|☞|☛|※)\s*$/g;
    return _content.replace(regexSymbols2, '');
}
export function formatATags(originContent, config) {
    if (!originContent) {
        return originContent;
    }
    const regexSymbols = /<a\s+([^>]*?href=["']([^"']*)["'])([^>]*?target=["']([^"']*)["'])?([^>]*?)>(.*?)<\/a>/gi;
    const results = [];
    return originContent.replace(regexSymbols, function (match, p1, href, p3, p4, p5, content) {
        const _href = href.trim();
        const isTel = _href.startsWith('tel:');
        const isMail = _href.startsWith('mailto:');
        const isSms = _href.startsWith('sms:');
        const isJavascript = _href.startsWith('javascript:');
        const isGeo = _href.startsWith('geo:');
        if (isTel || isMail || isSms || isJavascript || isGeo) {
            return match;
        }
        const clickName = `clickToNewPage_${new Date().getTime()}`;
        window[clickName] = () => {
            if (!_href) {
                return;
            }
        };
        return `<a onclick="${clickName}()">${content}</a>`;
    });
}
export function getSelfFunctionComp(originContent, config) {
    const { handleJump } = config || {};
    return originContent.replace(/\[bselffunc\](.*?)\[eselffunc\]/g, function (match, tag, content) {
        const tags = tag.split('###') || [];
        const clickName = `clickToMenu_${tags[0]}`;
        window[clickName] = () => {
            if (!tags.length) {
                return;
            }
            handleJump({
                sFuncid: tags[0],
                sFuncUrl: tags[2] === 'YJSS' ? 'YJSS' : 'JUMP',
                sFuncTitle: tags[1]
            });
        };
        return `***<div class="card-template-buttons card-template-buttons-old"><div
          role="button"
          tabIndex={0}
          class="card-template-button"
              onclick="${clickName}()"
            ><span> ${tags[1]}</span><div
              role="button"
              class="card-template-buttons-arrow"
            ></div></div></div>***`;
    });
}
export function getSelfEmoji(originContent, config) {
    if (!originContent) {
        return originContent;
    }
    const { type } = config || {};
    return originContent.replace(/\[bemoji\](.*?)\[eemoji\]/g, (match, tag) => {
        try {
            if (type === 'title') {
                return '';
            }
            return `<img aria-hidden="true" src=${`emoji/${tag}.png`} style="width: 1.3em; height: 1.3em;">`;
        }
        catch (e) {
            console.error(`Emoji not found: ${tag}`, e);
            return '';
        }
    });
}
export function getSelfText(originContent) {
    if (!originContent) {
        return originContent;
    }
    const tags = originContent.split('***').filter((part) => part.trim() !== '');
    const handleCotent = tags.map((tag) => {
        if (tag) {
            if (tag.startsWith('<div class="card-template-buttons card-template-buttons-old')) {
                return tag;
            }
            return `<div class="card-template-answer">${tag}</div>`;
        }
    });
    return handleCotent.join('');
}
export function generateRandomString(length = 10) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    const timestamp = Date.now().toString(36);
    return timestamp + result;
}
